import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const QRCodeSection = ({ kiosk, kioskId }) => {
  if (!kiosk) return null;
  
  return (
    <Card className="max-w-md mx-auto bg-white text-foreground" data-testid="qr-section">
      <CardHeader>
        <CardTitle className="text-center font-heading text-2xl">
          Scan to Start
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-center p-8">
          <img
            src={`${API}/kiosks/${kioskId}/qr-image`}
            alt="Kiosk QR Code"
            className="w-64 h-64 border-4 border-primary rounded-lg"
            data-testid="kiosk-qr-image"
          />
        </div>
        <p className="text-center text-muted-foreground">
          Use your phone camera to scan this QR code
        </p>
      </CardContent>
    </Card>
  );
};

export default QRCodeSection;
